import "./ProjectTreeRowParent.css";

import { useDispatch } from "react-redux";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { changeChildsVisible, setProjectTreeVisible } from "slices/project_work";

import ProjectTreeRowComment from "./ProjectTreeRowComment";
import ProjectTreeRowName from "./ProjectTreeRowName";
import ProjectTreeRowWrapper from "./ProjectTreeRowWrapper";
import useTreeRow from "./useTreeRow";

const ProjectTreeRowParent = ({ rowObj, paddingLeft, fontSize, callbacks }) => {
	const hasChilds = rowObj._children?.length > 0;
	const dispatch = useDispatch();
	const { getStyle } = useTreeRow();

	const changeChildrenVisible = () => {
		const body = {
			project_id: rowObj.project_id,
			key: rowObj.key,
			visible: rowObj.childs_visible === undefined ? false : !rowObj.childs_visible,
		};
		dispatch(setProjectTreeVisible({ body }));
		dispatch(changeChildsVisible(rowObj.key));
	};

	return (
		<>
			<div className="project-tree-row" style={{ paddingLeft: paddingLeft, width: `calc(100% - ${paddingLeft}px)`, ...getStyle({ rowObj }) }}>
				{hasChilds ? (
					<span className="parent-icon" onClick={changeChildrenVisible}>
						{rowObj.childs_visible === false ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
					</span>
				) : (
					<span style={{ paddingLeft: 18 }} />
				)}
				<ProjectTreeRowName rowObj={rowObj} fontSize={fontSize} callbacks={callbacks} />
				{rowObj?._has_comment && <ProjectTreeRowComment rowObj={rowObj} callbacks={callbacks} />}
			</div>
			{hasChilds === true &&
				rowObj.childs_visible !== false &&
				rowObj._children?.map((chObj) => {
					return <ProjectTreeRowWrapper key={chObj.key} rowObj={chObj} callbacks={callbacks} />;
				})}
		</>
	);
};

export default ProjectTreeRowParent;
